// @unocss-include
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog } from '@a-type/ui';
import { Link } from '@verdant-web/react-router';
import { useContext, useEffect, useState } from 'react';
import { CONFIG, VerdantContext } from '../index.js';
import { useLocalStorage } from '../react.js';
export function DeveloperErrorDialog(props) {
    const verdant = useContext(VerdantContext);
    const [error, setError] = useState(null);
    useEffect(() => {
        let unsub;
        verdant === null || verdant === void 0 ? void 0 : verdant.open().then((client) => {
            unsub = client.subscribe('developerError', setError);
        });
        return () => {
            unsub === null || unsub === void 0 ? void 0 : unsub();
        };
    }, [verdant]);
    const [lastReloadTime, setLastReloadTime] = useLocalStorage('developerError-lastReload', 0, false);
    const justReloaded = Date.now() - lastReloadTime < 2000;
    const reload = () => {
        setLastReloadTime(Date.now());
        window.location.reload();
    };
    return (_jsx(Dialog, Object.assign({}, props, { open: !!error, children: _jsxs(Dialog.Content, { children: [_jsx(Dialog.Title, { children: "Data error" }), _jsxs(Dialog.Description, { children: ["Sorry to interrupt, but it seems something is fishy with this app's data.", ' ', justReloaded ?
                            "Seems reloading didn't fix it. To avoid data loss, please contact support."
                            : "Let's try reloading the app."] }), justReloaded ?
                    _jsxs(Dialog.Actions, { children: [_jsx(Button, { onClick: reload, children: "Reload again" }), _jsx(Button, { asChild: true, children: _jsx(Link, { to: `${CONFIG.HOME_ORIGIN}/contact`, newTab: true, children: "Contact support" }) })] })
                    : _jsx(Dialog.Actions, { children: _jsx(Button, { color: "primary", onClick: reload, children: "Reload" }) })] }) })));
}
//# sourceMappingURL=DeveloperErrorDialog.js.map